export default function WhyThisMatters() {
  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-3xl mx-auto">
        <div className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed">
          <p>
            In a world of AI tools and constant outreach, alignment is the real differentiator.
          </p>
          
          <p>
            The most powerful way to grow your business is through relationships with people who genuinely complement what you offer. People who share your values. People whose audiences you truly care about serving.
          </p>
          
          <p>
            I've never believed in competition as the path forward. One of my mentors runs an eight-figure health brand and regularly meets with people others would call competitors. They share what's working and explore how to leverage together.
          </p>
          
          <p>
            There's room for all of us when partnerships are aligned and rooted in trust.
          </p>
        </div>
      </div>
    </section>
  );
}